import React from 'react';
import { Modal } from '../../../../../components/ui/Modal';
import { Button } from '../../../../../components/ui/Button';
import { CourierLabels } from '../components/CourierLabels';

/**
 * What the courier answered, the moment it did.
 *
 * Etiquetar creates the shipment in a task, and the answer comes back over the
 * socket (`label_{role}_{user}`), so the operator is not left reading "Sin
 * etiqueta" and refreshing. The same block stays on the exit step and on the
 * order's detail once this closes.
 *
 * @param {object} props
 * @param {object|null} props.result - The socket payload; `null` keeps it closed.
 * @param {() => void} props.onClose
 */
export const LabelReadyModal = ({ result, onClose }) => {
  if (!result) return null;

  return (
    <Modal isOpen onClose={onClose} title="Envío creado en el courier" testId="label-ready-modal">
      <CourierLabels summary={result} testId="label-ready" />

      <div className="flex justify-end gap-3 mt-8">
        <Button variant="ghost" onClick={onClose} data-testid="label-ready-close">
          Cerrar
        </Button>
      </div>
    </Modal>
  );
};
